var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 71.5L75 10.46L132.54 71.5H17.46Z",
    fill: "#B4C5D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.38 43.05V127.17C119.38 128.563 118.827 129.9 117.843 130.886C116.859 131.872 115.523 132.427 114.13 132.43H39.23C38.5411 132.429 37.8591 132.292 37.2232 132.026C36.5873 131.761 36.01 131.373 35.5242 130.885C35.0384 130.396 34.6537 129.817 34.3922 129.179C34.1307 128.542 33.9974 127.859 34 127.17V29.78C34 28.3867 34.5528 27.0503 35.5371 26.0642C36.5214 25.078 37.8567 24.5227 39.25 24.52H101.71L119.38 43.05Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 48.3702C58.9091 48.3702 61.47 45.8092 61.47 42.6502C61.47 39.4911 58.9091 36.9302 55.75 36.9302C52.591 36.9302 50.03 39.4911 50.03 42.6502C50.03 45.8092 52.591 48.3702 55.75 48.3702Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 74.1099C58.9091 74.1099 61.47 71.549 61.47 68.3899C61.47 65.2309 58.9091 62.6699 55.75 62.6699C52.591 62.6699 50.03 65.2309 50.03 68.3899C50.03 71.549 52.591 74.1099 55.75 74.1099Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.19 43.0598H101.97V22.8398",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5801 24.3899C49.5801 23.2547 50.031 22.1661 50.8337 21.3634C51.6363 20.5608 52.725 20.1099 53.8601 20.1099C54.9952 20.1099 56.0838 20.5608 56.8865 21.3634C57.6891 22.1661 58.1401 23.2547 58.1401 24.3899V40.8399C58.1401 41.4074 57.9146 41.9517 57.5133 42.3531C57.112 42.7544 56.5676 42.9799 56.0001 42.9799C55.4325 42.9799 54.8882 42.7544 54.4869 42.3531C54.0855 41.9517 53.8601 41.4074 53.8601 40.8399V30.1999",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6001 47.6299H91.8901",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6001 54.8301H91.8901",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6001 65.5601H99.7601",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 71.5H132.54V120.67C132.54 124.15 131.158 127.487 128.697 129.947C126.237 132.408 122.9 133.79 119.42 133.79H30.58C27.1003 133.79 23.7632 132.408 21.3027 129.947C18.8422 127.487 17.46 124.15 17.46 120.67V71.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 71.5V120.22C17.4599 123.815 18.8852 127.263 21.4233 129.808C23.9614 132.354 27.4053 133.789 31 133.8H119C122.602 133.8 126.056 132.369 128.602 129.823C131.149 127.276 132.58 123.822 132.58 120.22V71.5",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 72.6802L75 101.07L28.36 129.69",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.54 72.6802L75 101.07L121.63 129.69",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen);
export default __webpack_public_path__ + "static/media/envelope_open.dd1633d778eb253fc1af6827d38eb16e.svg";
export { ForwardRef as ReactComponent };